<app-modal-actionable iconSrc="assets/ico/clipboard-regular.svg" title="Note" color="green" [data]="data"
    dataIconSrc="assets/ico/grading.svg">
    <div icon class="modal-icon icon fill-white" aria-label="clipboard" [inlineSVG]="'assets/ico/clipboard-regular.svg'"></div>

    <div content>
        <apc-action-card>
            <apc-save-back-action-buttons buttons></apc-save-back-action-buttons>
            <div content class="fullwidth">
                <div class="container-fluid">
                    <div class="row">
                        <div class="form-group col-lg">
                            <label>Tipologia</label>
                            <select class="form-control">
                                <option>Generic</option>
                            </select>
                        </div>
                        <div class="form-group col-lg">
                            <label>Data inizio validità</label>
                            <input class="form-control" type="date" />
                        </div>
                        <div class="form-group col-lg">
                            <label>Data fine validità</label>
                            <input class="form-control" type="date" />
                        </div>
                        <div class="form-group col-lg bell-icon">
                            <apc-ui-switch>
                                <span label>
                                    <div class="icon" aria-label="bell"
                                        [inlineSVG]="'assets/ico/notifications_active.svg'"></div>
                                </span>
                            </apc-ui-switch>
                        </div>
                        <div class="form-group col-lg-12 mt-4">
                            <textarea class="form-control" type="text" placeholder="Descrizione generica…"
                                rows="8"></textarea>
                        </div>
                    </div>
                </div>
            </div>
        </apc-action-card>
    </div>
</app-modal-actionable>